import useWebSocket from 'react-use-websocket';
import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import { getAccessToken } from '../../common/utils/cookie-service';
import { getUserRole } from '../../common/utils/auth-service';
import { UserRole } from '../../common/utils/enum';

const NotificationListener: React.FC = (): JSX.Element => {
  const webSocketBaseUrl = process.env.REACT_APP_NOTIFICATION_WEB_SOCKET_URL;
  const accessToken = getAccessToken();
  const [webSocketUrl, setWebSocketUrl] = React.useState<string | null>(null);
  const { lastMessage } = useWebSocket(webSocketUrl, {
    shouldReconnect: () => true
  });
  const userRole = getUserRole();

  useEffect(() => {
    if (lastMessage !== null) {
      const message = JSON.parse(lastMessage.data);
      toast(message.title);
    }
  }, [lastMessage]);

  useEffect(() => {
    if (
      accessToken &&
      webSocketBaseUrl &&
      userRole &&
      userRole !== UserRole.Member
    ) {
      setWebSocketUrl(webSocketBaseUrl + '?token=' + accessToken);
    }
  }, [accessToken, userRole]);

  return <></>;
};

export default NotificationListener;
